import './BasicLogin.scss';
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import Button from '@mui/material/Button';
import Button from '../comm/HongButton';
import axios from "axios";
import fnc from '../mymod/commFunction';
import { useSelector, useDispatch } from 'react-redux';
import { store2 } from '../store';
import { setIsLoggedIn, setUserInfo, setUserInfo2, setAcaName, setChoJoongGo, setIsPaid } from '../reduxToolkit/redux';
import { Checkbox } from '@mui/material';
import fncS4 from '../mymod/commFunction4';
// Firebase imports
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { firestore } from '../page_firebase/firebaseConfig';
import { normalizeAcaCode, normalizeChatUserId } from '../mymod/normalizeAcaCode';
import { forgetGuardianDevice, isGuardianAutoLoginPaused, resumeGuardianAutoLogin } from '../mymod/appSession';
import {
  APP_STORE_URLS,
  detectMobilePlatform,
  extractAppVersion,
  getAppUpdateRequirement,
  isNativeAppEnvironment
} from '../mymod/appRelease';
import { fetchAppRelease } from '../mymod/appReleaseApi';

const LOGIN_CERT_CODE = 'FD2001';
const isFixedLoginCode = (value) => [LOGIN_CERT_CODE, '2001'].includes(normalizeAcaCode(value));
const isFixedParentSession = (session) => Boolean(session
  && isFixedLoginCode(session.certCode || session.acaCode)
  && isFixedLoginCode(session.acaCode || session.certCode));
const PARENT_SESSION_STORAGE_KEY = 'guardianLoginSession';
const PARENT_SESSION_LIST_STORAGE_KEY = 'guardianLoginSessions';
const PARENT_REMEMBER_STORAGE_KEY = 'guardianRememberDevice';
const readParentRememberPreference = () => {
  try { return localStorage.getItem(PARENT_REMEMBER_STORAGE_KEY); } catch { return null; }
};
const getParentSessionStorage = () => readParentRememberPreference() === 'false' ? sessionStorage : localStorage;
const STUDENT_ID_STORAGE_KEY = 'studentLoginId';
const STUDENT_PASSWORD_STORAGE_KEY = 'studentLoginPassword';
const LOGIN_MODE_STORAGE_KEY = 'lastLoginMode';
const APP_SESSION_TOKEN_STORAGE_KEY = 'appSessionToken';
const APP_SESSION_EXPIRES_STORAGE_KEY = 'appSessionExpiresAt';

const clearStoredAppSession = () => {
  try {
    localStorage.removeItem(APP_SESSION_TOKEN_STORAGE_KEY);
    localStorage.removeItem(APP_SESSION_EXPIRES_STORAGE_KEY);
    sessionStorage.removeItem(APP_SESSION_TOKEN_STORAGE_KEY);
    sessionStorage.removeItem(APP_SESSION_EXPIRES_STORAGE_KEY);
  } catch (error) {
    // 저장소를 사용할 수 없는 환경에서도 로그인 자체는 계속 진행한다.
  }
  window.dispatchEvent(new Event('billing:updated'));
};

const saveStoredAppSession = (session, persistent = true) => {
  clearStoredAppSession();
  if (!session?.token) return false;

  const expiresAt = session.expiresAt || '';
  const expiresTime = new Date(expiresAt).getTime();
  const remainingDays = Number.isFinite(expiresTime)
    ? Math.max((expiresTime - Date.now()) / (24 * 60 * 60 * 1000), 1)
    : 30;

  fnc.setCookie(APP_SESSION_TOKEN_STORAGE_KEY, session.token, remainingDays, persistent);
  if (expiresAt) {
    fnc.setCookie(APP_SESSION_EXPIRES_STORAGE_KEY, expiresAt, remainingDays, persistent);
  }

  const storedToken = fnc.getCookie(APP_SESSION_TOKEN_STORAGE_KEY);
  if (storedToken !== session.token) {
    clearStoredAppSession();
    return false;
  }
  return true;
};

const readStoredLoginMode = () => {
  try {
    const storedMode = localStorage.getItem(LOGIN_MODE_STORAGE_KEY);
    if (storedMode === 'student' || storedMode === 'parent') {
      return storedMode;
    }
  } catch (error) {
    // localStorage를 사용할 수 없는 환경에서는 기존 쿠키 저장값을 사용한다.
  }

  const cookieMode = fnc.getCookie('loginMode');
  return cookieMode === 'student' || cookieMode === 'parent' ? cookieMode : '';
};

const saveLoginMode = (mode) => {
  if (mode !== 'student' && mode !== 'parent') {
    return;
  }

  try {
    localStorage.setItem(LOGIN_MODE_STORAGE_KEY, mode);
  } catch (error) {
    // WebView 저장소가 차단되어도 쿠키 저장은 계속한다.
  }

  fnc.setCookie('loginMode', mode, 1000);
};

function BasicLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const signupCertCode = normalizeAcaCode(location.state?.signupCertCode) === LOGIN_CERT_CODE ? LOGIN_CERT_CODE : '';
  const signupLoginId = typeof location.state?.signupLoginId === 'string' ? location.state.signupLoginId : '';
  const recoveredLoginId = typeof location.state?.recoveredLoginId === 'string' ? location.state.recoveredLoginId : '';
  const passwordReset = location.state?.passwordReset === true;
  const dispatch = useDispatch();
  const certCode = LOGIN_CERT_CODE;
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [loginMode, setLoginMode] = useState(() => readStoredLoginMode() || 'student');
  const [parentPhone, setParentPhone] = useState('');
  const [parentCode, setParentCode] = useState('');
  const [parentCodeSent, setParentCodeSent] = useState(false);
  const [parentLoading, setParentLoading] = useState(false);
  const [parentMessage, setParentMessage] = useState('');
  const [parentSavedSessionAvailable, setParentSavedSessionAvailable] = useState(false);
  const [parentRememberDevice, setParentRememberDevice] = useState(() => readParentRememberPreference() !== 'false');
  const [appUpdateInfo, setAppUpdateInfo] = useState(null);
  const [isAppVersionChecking, setIsAppVersionChecking] = useState(true);
  const userIdRef = useRef(null);  // useRef 훅을 사용해 참조 생성
  const passwordRef = useRef(null);
  const parentAutoLoginTriedRef = useRef(false);
  const parentAutoLoginSessionRef = useRef(null);
  const parentRequestRef = useRef(0);
  const parentBusyRef = useRef(false);
  const stCode = fnc.getCookie('stCode');//getCookie함수 수정 utf-8에러 남
  const version = useSelector(state => state.reduxStore.version);
  
  const [isAutoLoginChecked, setAutoLoginChecked] = useState(false);
  const [isIdChecked, setIdChecked] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const appVersion = useSelector(state => state.reduxStore.appVersion);
  const fcmToken = useSelector(state => state.reduxStore.fcmToken);

  const currentVersion = localStorage.getItem('updateVersion');
  const acaName = useSelector(state => state.reduxStore.acaName);
  const nativeVersionFromUrl = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('nativeVersion') || ''
    : '';


  const deviceInfo = localStorage.getItem('DeviceInfo') || '';//html과 index.js에 있음
  // const fcmToken = localStorage.getItem('FcmToken');
  const deviceKind = localStorage.getItem('DeviceKind') || '';
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const hasAndroidBridge = Boolean(window.myJSInterface);
  const hasIosBridge = Boolean(window.webkit?.messageHandlers?.callWebSite);
  const appPlatform = detectMobilePlatform(
    deviceKind, nativeVersionFromUrl, version, appVersion,
    hasAndroidBridge ? 'android' : '', hasIosBridge ? 'ios' : '', userAgent
  );
  const storedAppVersion = localStorage.getItem('AppVersion') || '';
  const installedVersionText = [nativeVersionFromUrl, version, appVersion, storedAppVersion]
    .find((value) => (
      value
      && !/^Application Version 1\.0$/i.test(String(value))
      && extractAppVersion(value)
    )) || '';
  const nativeApp = isNativeAppEnvironment({ deviceKind, userAgent, hasAndroidBridge, hasIosBridge });

  let acaDbName;

  const normalizePhone = (value) => String(value || '').replace(/[^0-9]/g, '');
  const makeParentLoginId = (phone) => {
    const normalizedPhone = normalizePhone(phone);
    return normalizedPhone ? `P_${normalizedPhone}` : '';
  };

  const getDeviceKey = () => {
    try {
      const parsedDeviceInfo = deviceInfo ? JSON.parse(deviceInfo) : null;
      const parsedKey = parsedDeviceInfo?.vendorID || parsedDeviceInfo?.vendorId || parsedDeviceInfo?.uuid || parsedDeviceInfo?.deviceId;
      if (parsedKey) return String(parsedKey).substring(0, 120);
    } catch (error) {
      // DeviceInfo는 앱/WebView마다 문자열 형태가 달라질 수 있어 실패해도 로그인은 계속 진행한다.
    }

    const browserKey = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    return String(deviceKind || browserKey || 'web').substring(0, 120);
  };

  /**
   * uid: "FD2001_kuku1234" 같은 당신 시스템 유저 ID
   * token: 안드로이드에서 받은 FCM 토큰
   */
  const saveFcmTokenToUser = async (uid, token) => {
    if (!uid || !token) {
      console.log("❌ uid 또는 token 없음");
      return;
    }

    try {
      const userRef = doc(firestore, "users", uid);
      
      // 먼저 기존 문서를 읽어서 현재 fcmTokens 확인
      const userSnap = await getDoc(userRef);
      
      let currentTokens = [];
      if (userSnap.exists()) {
        const userData = userSnap.data();
        currentTokens = Array.isArray(userData.fcmTokens) ? userData.fcmTokens : [];
      }
      
      // 기존 토큰은 유지하고 새 토큰만 추가한다.
      // 토큰이 이미 있어도 id 필드가 없는 기존 문서를 보정해야 하므로 저장은 계속한다.
      const updatedTokens = currentTokens.includes(token)
        ? currentTokens
        : [...currentTokens, token];

      await setDoc(
        userRef,
        {
          id: uid,
          fcmTokens: updatedTokens,
        },
        { merge: true }
      );

      console.log("✅ FCM 토큰 Firestore 저장 완료:", uid, "토큰 개수:", updatedTokens.length);
    } catch (err) {
      console.error("❌ FCM 토큰 저장 실패:", err);
    }
  };

  useEffect(() => {
    // 컴포넌트가 마운트될 때 input 요소에 포커스를 자동으로 맞춤
    restoreCookie();
    return () => {
      parentRequestRef.current += 1;
      parentBusyRef.current = false;
    };
    // userIdRef.current.focus(); 이거 하지마 팝업 떠서 귀찮아
  }, []);

  useEffect(() => {
    if (loginMode !== 'parent') {
      setParentSavedSessionAvailable(false);
      return;
    }

    const normalizedPhone = normalizePhone(parentPhone);
    if (!certCode || !normalizedPhone || normalizedPhone.length < 10) {
      setParentSavedSessionAvailable(false);
      return;
    }

    setParentSavedSessionAvailable(Boolean(getStoredParentSessionByPhone(certCode, normalizedPhone)));
  }, [loginMode, certCode, parentPhone]);

  useEffect(() => {
    let isActive = true;

    if (!appPlatform || (!installedVersionText && !nativeApp)) {
      setAppUpdateInfo(null);
      setIsAppVersionChecking(false);
      return;
    }

    if (!installedVersionText) {
      setAppUpdateInfo(null);
      setIsAppVersionChecking(true);
      const nativeVersionWaitTimeout = window.setTimeout(() => {
        if (isActive) setIsAppVersionChecking(false);
      }, 2000);

      return () => {
        isActive = false;
        window.clearTimeout(nativeVersionWaitTimeout);
      };
    }

    setIsAppVersionChecking(true);
    fetchAppRelease(appPlatform).then((res) => {
      if (!isActive) return;
      setIsAppVersionChecking(false);

      if (!res?.success || !res?.configured || !res?.release) {
        setAppUpdateInfo(null);
        return;
      }

      setAppUpdateInfo(
        getAppUpdateRequirement(installedVersionText, {
          ...res.release,
          platform: appPlatform
        })
      );
    }, () => {
      if (!isActive) return;
      setAppUpdateInfo(null);
      setIsAppVersionChecking(false);
    });

    return () => {
      isActive = false;
    };
  }, [appPlatform, installedVersionText, nativeApp]);

  const handleSubmit = (event) => {
    event.preventDefault(); // 폼 전송에 의한 페이지 새로고침 방지

    if (isAppVersionChecking) {
      alert('앱 버전을 확인하고 있습니다. 잠시 후 다시 시도해주세요.');
      return;
    }

    if (appUpdateInfo) {
      alert('최신 버전으로 업데이트한 후 로그인할 수 있습니다.');
      return;
    }

    if (loginMode === 'parent') {
      handleParentVerify();
      return;
    }
 
    if(!certCode){
      alert('인증코드를 입력하세요!');
      return false;
    }

    if(!userId){
      alert('아이디를 입력하세요!');
      return false;
    }
    if(!password){
      alert('패쓰워드를 입력하세요!');
      return false;
    }

    fncInfoAca();
  };


  function fncInfoAca(afterInfo, onError) {
    const lookupCertCode = certCode;
    fnc.sendAxios('/infoAca', { certCode: lookupCertCode }, (res) => {
      if (res && Array.isArray(res) && res[0] && res[0].acaDbName) {  
        let acaCode = normalizeAcaCode(res[0].acaCode);
        acaDbName = res[0].acaDbName;
        const acaName = res[0].acaName;
        const s3_acaCode = res[0].s3_acaCode;
        const choJoongGo = res[0].choJoongGo;
        const isPaidValue = res[0].isPaid;
        
        fnc.setCookie('acaCode', acaCode, 1000);
        fnc.setCookie('acaDbName', acaDbName, 1000);
        fnc.setCookie('acaName', acaName, 1000);
        fnc.setCookie('s3_acaCode', s3_acaCode, 1000);
        // fnc.setCookie('choJoongGo', choJoongGo, 1000);   
        dispatch(setIsPaid(isPaidValue));
        dispatch(setAcaName(acaName));
        dispatch(setChoJoongGo(choJoongGo));
        updateDbName(acaDbName);//인증코드 변경시 두 번 클릭해야 dbName이 변경됨??(미해결)

        const acaInfo = { certCode: lookupCertCode, acaCode, acaDbName, acaName, s3_acaCode, choJoongGo, isPaid: isPaidValue };
        if (typeof afterInfo === 'function') {
          afterInfo(acaInfo);
        } else {
          fncBasicLogin(userId, password, acaCode);//로그인 실행
        }

      } else {
        alert('인증코드 정보가 올바르지 않습니다.');
        if (typeof onError === 'function') onError();
      }
    }, (error) => {
      if (typeof onError === 'function') onError(error);
    });
  }


  function updateDbName(acaDbName) {
    // 기존 인터셉터 제거
    axios.interceptors.request.handlers = [];//이거 없어서 고생
    // 새 인터셉터 등록
    axios.interceptors.request.use(config => {
      if (config.method === 'post' && config.data) {
        config.data.db = acaDbName;
      }
      return config;
    }, error => {
      console.error('Axios 요청 인터셉터에서 오류 발생:', error);
      return Promise.reject(error);
    });
  }


  function fncBasicLogin(loginId, pw, academyCodeOverride) {
    const loginCertCode = certCode;

    fnc.sendAxios('/kuesbLogin', {
      id: loginId,
      pw,
      acaCode: normalizeAcaCode(academyCodeOverride || fnc.getCookie('acaCode') || loginCertCode),
      certCode: loginCertCode,
      issueAppSession: true,
    }, (res) => {

      if (res.length) {

        const {
          appSessionToken,
          appSessionExpiresAt,
          appSessionError,
          ...authenticatedUser
        } = res[0];

        saveStoredAppSession({
          token: appSessionToken,
          expiresAt: appSessionExpiresAt,
        });
        if (appSessionError) {
          console.warn('로그인은 완료됐지만 사용자별 저장 세션을 발급하지 못했습니다.');
          alert('로그인은 완료됐지만 AI 첨삭 내역 기능을 준비하지 못했습니다. 잠시 후 다시 로그인해 주세요.');
        }

        dispatch(setUserInfo(authenticatedUser));
        dispatch(setIsLoggedIn(true));

        saveLoginMode('student');
        fnc.setCookie('certCode', loginCertCode);
        fnc.setCookie('id', authenticatedUser.id);
        localStorage.removeItem('pw');
        if (isIdChecked || isAutoLoginChecked) {
          fnc.setCookie(STUDENT_ID_STORAGE_KEY, authenticatedUser.id, 1000);
        } else {
          localStorage.removeItem(STUDENT_ID_STORAGE_KEY);
        }
        if (isAutoLoginChecked) {
          fnc.setCookie(STUDENT_PASSWORD_STORAGE_KEY, pw, 30);
        } else {
          localStorage.removeItem(STUDENT_PASSWORD_STORAGE_KEY);
        }
        fnc.setCookie('userRole', String(authenticatedUser.kind).trim() === '2' ? 'teacher' : 'student', 1000);
        fnc.setCookie('stCode', authenticatedUser.stCode);
        fnc.setCookie('userName', authenticatedUser.name);
        fnc.setCookie('email', authenticatedUser.email);
        fnc.setCookie('lastLoginTime', Date.now(), 1);

        // fnc.setCookie('acaCode', 2000);

        const stCode = authenticatedUser.stCode;

        if (deviceKind) {//ios 또는 android일 때만        
          fncSavePushToken(loginId, stCode, fcmToken ?? '', deviceInfo ?? '', deviceKind ?? '');
        }

        const acaCode = loginCertCode;
        const fullUserId = normalizeChatUserId(authenticatedUser.id, acaCode);
        const nickname = authenticatedUser.name || '';
        const profile_image = '';
        const id2 = authenticatedUser.id;//basic login은 id2 없음

        // socialLogin 조회가 끝나기 전 Talk으로 이동해도 항상 정규화된 ID를 사용한다.
        dispatch(setUserInfo2({
          acaCode,
          nickname,
          email: authenticatedUser.email || '',
          id: fullUserId,
          id2,
          profile_image,
          uid: ''
        }));


        // ✅ 로그인 성공 시 FCM 토큰을 Firestore에 저장
        const uid = fullUserId; // 예: "FD2001_kuku1234"
        const latestFcmToken = store2.getState().reduxStore.fcmToken;
        if (uid && latestFcmToken) {
            saveFcmTokenToUser(uid, latestFcmToken);
        }


        fncInsertSocialLogin(acaCode, fullUserId, id2, nickname, profile_image);
        navigate('/menu');
    
      } else {
        alert('정보가 올바르지 않습니다.')
        console.log(res,"속성이 obj 내에 없습니다.");
      }
    });
  }

  function fncInsertSocialLogin(acaCode, id, id2, nickname, profile_image) {
          fnc.sendAxios('/socialLoginRoutes/insert/socialLogin_basicLogin', { acaCode, id, id2, nickname, profile_image, isSocialLogin: 'N' }, (res) => {
              if (res?.success) {
                  fncSelectSocialLogin(id);
              } else {
                  // 기본 로그인은 이미 성공했으므로 보조 프로필 동기화 실패로 로그인 실패 알림을 띄우지 않는다.
                  console.warn('socialLogin 프로필 저장 실패:', res);
              }
          });
      
  }


 function fncSelectSocialLogin(id) {
        fnc.sendAxios('/socialLoginRoutes/select/socialLogin', { id }, (res) => {
            if (res && res.length > 0) {
                const normalizedAcaCode = normalizeAcaCode(res[0].acaCode || certCode);
                const normalizedId = normalizeChatUserId(res[0].id, normalizedAcaCode);
                dispatch(setUserInfo2({
                    acaCode: normalizedAcaCode,
                    nickname: res[0].nickname || '',
                    email: res[0].email || '',
                    id: normalizedId,
                    id2: res[0].id2 || '',//naver id 등 social login id 닉네임 아이디 임
                    profile_image: res[0].profile_image || '',
                    uid: res[0].uid || '' // firebase uid
                }));

                console.log(res, 'userinfo2 res');
                dispatch(setIsLoggedIn(true));
            } else {
                // 로그인 성공 후 실행되는 보조 조회이므로 빈 결과는 경고만 남긴다.
                console.warn('socialLogin 프로필 조회 결과가 없습니다:', res);
            }
        });
    }

function fncSavePushToken(id, stCode, fcmToken, deviceInfo) {
  fnc.sendAxios('/kuesbPushRoutes/save/push', { id, stCode, fcmToken, deviceInfo, deviceKind }, (res) => {
    if (res) {
      console.log(res, 'save Token');
    } else {
      console.log(res,"속성이 obj 내에 없습니다.");
    }
  });
}

const handleParentSendCode = () => {
  if (parentBusyRef.current) return;
  if (!certCode) {
    alert('인증코드를 입력하세요!');
    return;
  }

  const normalizedPhone = normalizePhone(parentPhone);
  if (!normalizedPhone || normalizedPhone.length < 10) {
    alert('학부모 휴대폰 번호를 입력하세요!');
    return;
  }

  setParentLoading(true);
  parentBusyRef.current = true;
  const requestId = ++parentRequestRef.current;
  setParentMessage('');

  fncInfoAca((acaInfo) => {
    if (requestId !== parentRequestRef.current) return;
    fnc.sendAxios('/socialLoginRoutes/guardian/sendLoginCode', {
      acaCode: acaInfo.acaCode || certCode,
      certCode,
      phone: normalizedPhone
    }, (res) => {
      if (requestId !== parentRequestRef.current) return;
      parentBusyRef.current = false;
      setParentLoading(false);
      if (res && res.success) {
        setParentCodeSent(true);
        setParentMessage(res.message || '인증번호가 전송되었습니다.');
        saveLoginMode('parent');
        if (isIdChecked) fnc.setCookie('parentPhone', normalizedPhone, 1000);
      } else {
        setParentMessage(res?.message || '인증번호 전송에 실패했습니다.');
      }
    }, () => {
      if (requestId !== parentRequestRef.current) return;
      parentBusyRef.current = false;
      setParentLoading(false);
      setParentMessage('인증번호를 전송하지 못했습니다. 연결을 확인하고 다시 시도해 주세요.');
    });
  }, () => {
    if (requestId !== parentRequestRef.current) return;
    parentBusyRef.current = false;
    setParentLoading(false);
    setParentMessage('서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.');
  });
};

const handleParentVerify = () => {
  if (parentBusyRef.current) return;
  if (!certCode) {
    alert('인증코드를 입력하세요!');
    return;
  }

  const normalizedPhone = normalizePhone(parentPhone);
  if (!normalizedPhone || normalizedPhone.length < 10) {
    alert('학부모 휴대폰 번호를 입력하세요!');
    return;
  }

  if (!parentCode) {
    const savedSession = getStoredParentSessionByPhone(certCode, normalizedPhone);
    if (savedSession) {
      parentAutoLoginTriedRef.current = true;
      tryParentAutoLogin(savedSession);
      return;
    }

    alert('인증번호를 입력하세요!');
    return;
  }
  setParentLoading(true);
  parentBusyRef.current = true;
  const requestId = ++parentRequestRef.current;
  setParentMessage('');

  fncInfoAca((acaInfo) => {
    if (requestId !== parentRequestRef.current) return;
    fnc.sendAxios('/socialLoginRoutes/guardian/verifyLoginCode', {
      acaCode: acaInfo.acaCode || certCode,
      certCode,
      phone: normalizedPhone,
      code: parentCode,
      deviceKey: getDeviceKey(),
      deviceInfo: deviceInfo || deviceKind || ''
    }, async (res) => {
      if (requestId !== parentRequestRef.current) return;
      if (res && res.success && res.user) {
        await applyParentLogin(res, requestId);
      } else {
        setParentMessage(res?.message || '학부모 로그인에 실패했습니다.');
      }
      if (requestId !== parentRequestRef.current) return;
      parentBusyRef.current = false;
      setParentLoading(false);
    }, () => {
      if (requestId !== parentRequestRef.current) return;
      parentBusyRef.current = false;
      setParentLoading(false);
      setParentMessage('로그인을 확인하지 못했습니다. 연결을 확인하고 다시 시도해 주세요.');
    });
  }, () => {
    if (requestId !== parentRequestRef.current) return;
    parentBusyRef.current = false;
    setParentLoading(false);
    setParentMessage('서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.');
  });
};

const parseGuardianSession = () => {
  const rawSession = fnc.getCookie('guardianSession');
  if (!rawSession) return null;

  try {
    const session = JSON.parse(rawSession);
    if (!session?.token || !session?.guardianId) return null;

    if (session.expiresAt) {
      const expiresAt = new Date(session.expiresAt).getTime();
      if (!Number.isNaN(expiresAt) && Date.now() > expiresAt) {
        localStorage.removeItem('guardianSession');
        sessionStorage.removeItem('guardianSession');
        return null;
      }
    }

    return session;
  } catch (error) {
    console.error('학부모 세션 복원 실패:', error);
    localStorage.removeItem('guardianSession');
    sessionStorage.removeItem('guardianSession');
    return null;
  }
};

function getParentSessionKey(certCodeValue, phoneValue) {
  const loginCertCode = normalizeAcaCode(certCodeValue);
  const phone = normalizePhone(phoneValue);
  if (!loginCertCode || !phone) return '';
  return `${loginCertCode}_${phone}`;
}

function normalizeParentSession(session) {
  if (!session) return null;
  const normalizedAcaCode = normalizeAcaCode(session.acaCode || session.certCode);
  return {
    ...session,
    acaCode: normalizedAcaCode,
    certCode: isFixedParentSession(session) ? LOGIN_CERT_CODE : normalizeAcaCode(session.certCode || normalizedAcaCode),
    guardianId: normalizeChatUserId(session.guardianId, normalizedAcaCode),
    phone: normalizePhone(session.phone || session.guardianPhone || '')
  };
}

function isValidParentSession(session) {
  const normalizedSession = normalizeParentSession(session);
  if (!normalizedSession?.token || !normalizedSession?.guardianId || !(normalizedSession.certCode || normalizedSession.acaCode)) {
    return false;
  }

  if (normalizedSession.expiresAt) {
    const expiresAt = new Date(normalizedSession.expiresAt).getTime();
    if (!Number.isNaN(expiresAt) && expiresAt <= Date.now()) {
      return false;
    }
  }

  return true;
}

function getStoredParentSessionMap(storage = getParentSessionStorage()) {
  try {
    const rawSessions = storage.getItem(PARENT_SESSION_LIST_STORAGE_KEY);
    if (!rawSessions) return {};

    const sessions = JSON.parse(rawSessions);
    if (!sessions || typeof sessions !== 'object' || Array.isArray(sessions)) {
      storage.removeItem(PARENT_SESSION_LIST_STORAGE_KEY);
      return {};
    }

    return sessions;
  } catch (error) {
    storage.removeItem(PARENT_SESSION_LIST_STORAGE_KEY);
    return {};
  }
}

function saveStoredParentSessionMap(sessions, storage = getParentSessionStorage()) {
  storage.setItem(PARENT_SESSION_LIST_STORAGE_KEY, JSON.stringify(sessions));
}

function getStoredParentSession() {
  // 선택값 변경만으로 현재 탭에 보관한 인증을 놓치지 않는다.
  for (const storage of [sessionStorage, localStorage]) {
    try {
      const rawSession = storage.getItem(PARENT_SESSION_STORAGE_KEY);
      if (rawSession) {
        const session = normalizeParentSession(JSON.parse(rawSession));
        if (isValidParentSession(session)) return isFixedParentSession(session) ? session : null;
        storage.removeItem(PARENT_SESSION_STORAGE_KEY);
      }
    } catch (error) {
      storage.removeItem(PARENT_SESSION_STORAGE_KEY);
    }
  }

  const legacySession = normalizeParentSession(parseGuardianSession());
  return isValidParentSession(legacySession) && isFixedParentSession(legacySession) ? legacySession : null;
}

function getStoredParentSessionByPhone(certCodeValue, phoneValue) {
  const sessionKey = getParentSessionKey(certCodeValue, phoneValue);
  if (!sessionKey) return null;

  const requestedCode = normalizeAcaCode(certCodeValue);
  const requestedPhone = normalizePhone(phoneValue);
  for (const storage of [sessionStorage, localStorage]) {
    const sessions = getStoredParentSessionMap(storage);
    const session = normalizeParentSession(sessions[sessionKey]);
    if (isValidParentSession(session) && isFixedParentSession(session) && session.phone === requestedPhone) return session;

    if (session) {
      delete sessions[sessionKey];
      saveStoredParentSessionMap(sessions, storage);
    }

    const matchingSession = Object.values(sessions)
      .map(normalizeParentSession)
      .find((savedSession) => {
        if (!isValidParentSession(savedSession) || !isFixedParentSession(savedSession) || savedSession.phone !== requestedPhone) return false;
        return [savedSession.certCode, savedSession.acaCode]
          .map(normalizeAcaCode)
          .includes(requestedCode);
      });

    if (matchingSession) {
      // 조회 중에는 저장 위치를 바꾸지 않고, 로그인 성공 후 선택값을 적용한다.
      sessions[sessionKey] = matchingSession;
      saveStoredParentSessionMap(sessions, storage);
      return matchingSession;
    }
  }

  const lastSession = getStoredParentSession();
  const lastSessionPhone = normalizePhone(lastSession?.phone || lastSession?.guardianPhone);
  const lastSessionCodes = [lastSession?.certCode, lastSession?.acaCode].map(normalizeAcaCode);
  return lastSessionPhone === requestedPhone && lastSessionCodes.includes(requestedCode) ? lastSession : null;
}

function saveParentSession(session, parentUser, phone) {
  if (!session?.token) return;

  const sessionData = normalizeParentSession({
    token: session.token,
    guardianId: session.guardianId || parentUser?.id || '',
    acaCode: session.acaCode || parentUser?.acaCode || certCode || '',
    certCode: session.certCode || certCode || session.acaCode || parentUser?.acaCode || '',
    guardianPhone: session.guardianPhone || parentUser?.phone || parentUser?.hp || phone || '',
    phone: session.guardianPhone || parentUser?.phone || parentUser?.hp || phone || '',
    expiresAt: session.expiresAt || '',
    savedAt: Date.now()
  });

  if (!isValidParentSession(sessionData)) return;

  const storage = getParentSessionStorage();
  const otherStorage = storage === localStorage ? sessionStorage : localStorage;
  otherStorage.removeItem(PARENT_SESSION_STORAGE_KEY);
  otherStorage.removeItem(PARENT_SESSION_LIST_STORAGE_KEY);
  storage.setItem(PARENT_SESSION_STORAGE_KEY, JSON.stringify(sessionData));

  const sessionKey = getParentSessionKey(sessionData.certCode || sessionData.acaCode, sessionData.phone);
  if (sessionKey) {
    const sessions = getStoredParentSessionMap();
    sessions[sessionKey] = sessionData;
    saveStoredParentSessionMap(sessions);
  }
}

function clearParentSession(session) {
  const normalizedSession = normalizeParentSession(session);
  for (const storage of [sessionStorage, localStorage]) {
    const sessions = getStoredParentSessionMap(storage);
    let sessionRemoved = false;
    Object.keys(sessions).forEach((key) => {
      const savedSession = normalizeParentSession(sessions[key]);
      const sameToken = normalizedSession?.token && savedSession?.token === normalizedSession.token;
      const sameGuardian = normalizedSession?.guardianId
        && savedSession?.guardianId === normalizedSession.guardianId
        && savedSession?.phone === normalizedSession.phone;

      if (sameToken || sameGuardian) {
        delete sessions[key];
        sessionRemoved = true;
      }
    });
    if (sessionRemoved) saveStoredParentSessionMap(sessions, storage);
  }

  setParentSavedSessionAvailable(false);
  setParentCodeSent(false);
  setParentCode('');
  localStorage.removeItem(PARENT_SESSION_STORAGE_KEY);
  localStorage.removeItem('guardianSession');
  sessionStorage.removeItem(PARENT_SESSION_STORAGE_KEY);
  sessionStorage.removeItem('guardianSession');
}
const tryParentAutoLogin = (savedSession) => {
  if (parentBusyRef.current) return;
  const certForAutoLogin = certCode;
  if (!isFixedParentSession(savedSession) || !savedSession?.token || !savedSession?.guardianId) return;

  setParentLoading(true);
  parentBusyRef.current = true;
  const requestId = ++parentRequestRef.current;
  setParentMessage('학부모 자동 로그인 중입니다.');

  fncInfoAca((acaInfo) => {
    if (requestId !== parentRequestRef.current) return;
    fnc.sendAxios('/socialLoginRoutes/guardian/autoLogin', {
      acaCode: savedSession.acaCode || acaInfo.acaCode || certForAutoLogin,
      certCode: certForAutoLogin,
      guardianId: savedSession.guardianId,
      token: savedSession.token,
      deviceKey: getDeviceKey(),
      deviceInfo: deviceInfo || deviceKind || ''
    }, async (res) => {
      if (requestId !== parentRequestRef.current) return;
      if (res && res.success && res.user) {
        await applyParentLogin(res, requestId);
      } else {
        const message = res?.message || '저장된 로그인으로 접속하지 못했습니다. 잠시 후 다시 시도해주세요.';
        const sessionExpired = /만료|자동로그인 정보가 없습니다|다시 인증/.test(message);
        if (sessionExpired) {
          clearParentSession(savedSession);
          setParentMessage('저장된 로그인 정보가 만료되었습니다. 인증번호를 다시 받아 로그인해주세요.');
        } else {
          // 일시적인 서버/네트워크 오류로 정상 세션을 지우면 다음 로그인 때 SMS 인증을 다시 요구하게 된다.
          setParentSavedSessionAvailable(true);
          setParentMessage(message);
        }
      }
      if (requestId !== parentRequestRef.current) return;
      parentBusyRef.current = false;
      setParentLoading(false);
    }, () => {
      if (requestId !== parentRequestRef.current) return;
      parentBusyRef.current = false;
      setParentLoading(false);
      setParentSavedSessionAvailable(true);
      setParentMessage('저장된 로그인으로 접속하지 못했습니다. 연결을 확인하고 다시 시도해 주세요.');
    });
  }, () => {
    if (requestId !== parentRequestRef.current) return;
    parentBusyRef.current = false;
    setParentLoading(false);
    setParentSavedSessionAvailable(true);
    setParentMessage('저장된 로그인으로 접속하지 못했습니다. 잠시 후 다시 시도해주세요.');
  });
};
const applyParentLogin = async ({ user, session, appSession }, requestId) => {
  const normalizedPhone = normalizePhone(user?.phone || user?.hp || parentPhone);
  const guardianAcaCode = normalizeAcaCode(user?.acaCode || session?.acaCode || certCode);
  const guardianId = normalizeChatUserId(
    user?.id || session?.guardianId || `P_${normalizedPhone}`,
    guardianAcaCode
  );
  const guardianLoginId = user?.id2 || makeParentLoginId(normalizedPhone);
  const guardianName = user?.nickname || user?.name || '학부모';
  const loginCertCode = certCode;

  const parentUserInfo = {
    ...user,
    role: 'parent',
    kind: '학부모',
    acaCode: guardianAcaCode,
    stCode: '',
    id: guardianId,
    id2: guardianLoginId,
    name: guardianName,
    nickname: guardianName,
    hp: normalizedPhone,
    phone: normalizedPhone,
    email: user?.email || '',
    profile_image: user?.profile_image || '',
    uid: user?.uid || ''
  };

  dispatch(setUserInfo(parentUserInfo));
  dispatch(setUserInfo2(parentUserInfo));
  dispatch(setIsLoggedIn(true));

  saveLoginMode('parent');
  localStorage.setItem(PARENT_REMEMBER_STORAGE_KEY, String(parentRememberDevice));
  fnc.setCookie('certCode', loginCertCode, 1000, parentRememberDevice);
  fnc.setCookie('acaCode', guardianAcaCode, 1000, parentRememberDevice);
  fnc.setCookie('id', guardianId, 1000, parentRememberDevice);
  fnc.setCookie('parentPhone', normalizedPhone, 1000, parentRememberDevice);
  fnc.setCookie('hp', normalizedPhone, 1000, parentRememberDevice);
  fnc.setCookie('userRole', 'parent', 1000, parentRememberDevice);
  fnc.setCookie('stCode', '', 1000, parentRememberDevice);
  setParentPhone(normalizedPhone);
  setParentCode('');
  setParentMessage('');
  fnc.setCookie('guardianId', guardianId, 1000, parentRememberDevice);
  fnc.setCookie('userName', guardianName, 1000, parentRememberDevice);
  fnc.setCookie('lastLoginTime', Date.now(), 1, parentRememberDevice);

  if (!saveStoredAppSession(appSession, parentRememberDevice)) {
    alert('로그인은 완료됐지만 AI 첨삭 내역 기능을 준비하지 못했습니다. 잠시 후 다시 로그인해 주세요.');
  }

  if (session?.token) {
    const parentSession = {
      token: session.token,
      guardianId,
      acaCode: guardianAcaCode,
      certCode: loginCertCode,
      guardianPhone: normalizedPhone,
      phone: normalizedPhone,
      expiresAt: session.expiresAt || ''
    };

    fnc.setCookie('guardianSession', JSON.stringify(parentSession), 1000, parentRememberDevice);
    saveParentSession(parentSession, parentUserInfo, normalizedPhone);
    setParentSavedSessionAvailable(true);
  }
  const latestFcmToken = store2.getState().reduxStore.fcmToken;
  if (guardianId && latestFcmToken) {
    await saveFcmTokenToUser(guardianId, latestFcmToken);
  }

  if (requestId === parentRequestRef.current) {
    resumeGuardianAutoLogin();
    navigate('/menu', { replace: true });
  }
};

useEffect(() => {
  if (isAppVersionChecking || appUpdateInfo || parentAutoLoginTriedRef.current || isGuardianAutoLoginPaused()) return;
  const savedSession = parentAutoLoginSessionRef.current;
  if (loginMode !== 'parent' || !parentRememberDevice || !savedSession) return;
  parentAutoLoginTriedRef.current = true;
  tryParentAutoLogin(savedSession);
}, [isAppVersionChecking, appUpdateInfo, loginMode, parentRememberDevice]);

const handleParentRememberChange = (event) => {
  const remember = event.target.checked;
  setParentRememberDevice(remember);
  localStorage.setItem(PARENT_REMEMBER_STORAGE_KEY, String(remember));
  parentAutoLoginSessionRef.current = null;
  if (remember) return; // 선택은 즉시 저장하고, 인증의 영구 저장은 로그인 성공 후에만 시작한다.

  // 선택 해제 시 기존 인증도 현재 탭에서만 사용한다.
  [PARENT_SESSION_STORAGE_KEY, PARENT_SESSION_LIST_STORAGE_KEY].forEach((key) => {
    const value = localStorage.getItem(key);
    if (value) sessionStorage.setItem(key, value);
    localStorage.removeItem(key);
  });
  if (fnc.getCookie('userRole') === 'parent') {
    ['certCode', 'acaCode', 'id', 'parentPhone', 'hp', 'userRole', 'stCode', 'guardianId', 'userName',
      'lastLoginTime', 'guardianSession', APP_SESSION_TOKEN_STORAGE_KEY, APP_SESSION_EXPIRES_STORAGE_KEY]
      .forEach((key) => {
        // 암호화된 값과 원래 만료 시간을 그대로 보존한다.
        const value = localStorage.getItem(key);
        if (value) sessionStorage.setItem(key, value);
        localStorage.removeItem(key);
      });
  } else {
    const value = localStorage.getItem('guardianSession');
    if (value) sessionStorage.setItem('guardianSession', value);
    localStorage.removeItem('guardianSession');
  }
};

const handleForgetGuardianDevice = async () => {
  if (parentBusyRef.current) return;
  const savedSession = getStoredParentSessionByPhone(certCode, parentPhone);
  if (!savedSession) return;
  parentAutoLoginSessionRef.current = null;
  parentBusyRef.current = true;
  setParentLoading(true);
  const requestId = ++parentRequestRef.current;
  const revoked = await forgetGuardianDevice(savedSession);
  if (requestId !== parentRequestRef.current) return;
  setParentSavedSessionAvailable(false);
  setParentCodeSent(false);
  setParentCode('');
  if (!fnc.getCookie('appSessionToken')) {
    dispatch(setIsLoggedIn(false));
    dispatch(setUserInfo({}));
    dispatch(setUserInfo2({}));
  }
  parentBusyRef.current = false;
  setParentLoading(false);
  setParentMessage(revoked
    ? '이 기기의 인증을 해제했습니다. 문자 인증 후 로그인해 주세요.'
    : '이 기기에 저장된 인증을 삭제했습니다. 서버에 연결하지 못해 서버 인증 해제는 확인하지 못했습니다.');
};

const handleLoginModeChange = (mode) => {
  parentAutoLoginSessionRef.current = null;
  if (loginMode === 'student' && mode !== 'student') {
    // 모바일 비밀번호 자동완성은 onChange 없이 DOM에만 값이 들어갈 수 있어 탭 전환 직전에 직접 보존한다.
    const currentStudentId = userIdRef.current?.value || userId;
    const currentStudentPassword = passwordRef.current?.value || password;

    if (currentStudentId) setUserId(currentStudentId);
    if (currentStudentPassword) setPassword(currentStudentPassword);
    if (isIdChecked && currentStudentId) {
      fnc.setCookie(STUDENT_ID_STORAGE_KEY, currentStudentId, 1000);
    }
    if (isAutoLoginChecked && currentStudentPassword) {
      fnc.setCookie(STUDENT_PASSWORD_STORAGE_KEY, currentStudentPassword, 30);
    }
  }

  setLoginMode(mode);
  setParentMessage('');
  saveLoginMode(mode);

  if (mode === 'student') {
    const savedStudentId = fnc.getCookie(STUDENT_ID_STORAGE_KEY);
    const savedStudentPassword = fnc.getCookie(STUDENT_PASSWORD_STORAGE_KEY);
    if (isIdChecked && savedStudentId) setUserId(savedStudentId);
    if (isAutoLoginChecked && savedStudentPassword) setPassword(savedStudentPassword);
  }
};

const handleIdClick = () => {
  if (isIdChecked) {
      setAutoLoginChecked(false);
      fnc.setCookie('isAutoLoginChecked', 'false', 1000);
  } else {
      const currentStudentId = userIdRef.current?.value || userId;
      if (currentStudentId) {
        setUserId(currentStudentId);
        fnc.setCookie(STUDENT_ID_STORAGE_KEY, currentStudentId, 1000);
      }
  }
  setIdChecked(prev => !prev);
  fnc.setCookie('isIdChecked', String(!isIdChecked), 1000);
}

const handleAutoLoginClick = () => {
  if (!isAutoLoginChecked) {
      setIdChecked(true);
      fnc.setCookie('isIdChecked', 'true', 1000);
      const currentStudentId = userIdRef.current?.value || userId;
      const currentStudentPassword = passwordRef.current?.value || password;
      if (currentStudentId) {
        setUserId(currentStudentId);
        fnc.setCookie(STUDENT_ID_STORAGE_KEY, currentStudentId, 1000);
      }
      if (currentStudentPassword) {
        setPassword(currentStudentPassword);
        fnc.setCookie(STUDENT_PASSWORD_STORAGE_KEY, currentStudentPassword, 30);
      }
  }
  setAutoLoginChecked(prev => !prev);
  fnc.setCookie('isAutoLoginChecked', String(!isAutoLoginChecked), 1000);
}


function restoreCookie() {//주의: ios는 쿠키 못읽어 localstorage에 저장함으로 변경
  fnc.setCookie('certCode', certCode, 1000);
  if (recoveredLoginId || passwordReset) {
    setUserId(recoveredLoginId);
    setPassword('');
    setLoginMode('student');
    setIdChecked(false);
    setAutoLoginChecked(false);
    if (passwordReset) {
      fnc.setCookie('pw', '', 0);
      fnc.setCookie(STUDENT_PASSWORD_STORAGE_KEY, '', 0);
      fnc.setCookie('isAutoLoginChecked', 'false', 1000);
      clearStoredAppSession();
      dispatch(setIsLoggedIn(false));
      dispatch(setUserInfo({}));
      dispatch(setUserInfo2({}));
    }
    return;
  }
  if (signupCertCode) {
    setUserId(signupLoginId);
    setPassword('');
    setLoginMode('student');
    setIdChecked(false);
    setAutoLoginChecked(false);
    return;
  }
  const id = fnc.getCookie('id');
  const pw = fnc.getCookie('pw');
  const savedStudentId = fnc.getCookie(STUDENT_ID_STORAGE_KEY)
    || (!/_P_[0-9]{10,11}$/.test(id || '') ? id : '');
  const savedStudentPassword = fnc.getCookie(STUDENT_PASSWORD_STORAGE_KEY) || pw;
  const savedParentPhone = normalizePhone(fnc.getCookie('parentPhone'));
  const hp = normalizePhone(fnc.getCookie('hp'));
  const savedLoginMode = readStoredLoginMode();
  const userRole = fnc.getCookie('userRole');
  const savedGuardianSession = getStoredParentSession();
  const isIdChecked = fnc.getCookie('isIdChecked') === 'true';
  const isAutoLoginChecked = fnc.getCookie('isAutoLoginChecked') === 'true';
  const isParentLoginCookie = savedLoginMode === 'parent'
    || (!savedLoginMode && (userRole === 'parent' || /^.+_P_[0-9]{10,11}$/.test(id || '')));

  setIdChecked(isIdChecked);
  setAutoLoginChecked(isAutoLoginChecked);

  if (savedStudentId && isIdChecked) {
    setUserId(savedStudentId);
  }

  if (savedStudentPassword && isAutoLoginChecked) {
    setPassword(savedStudentPassword);
  }

  if (savedGuardianSession && savedLoginMode !== 'student') {
    setLoginMode('parent');
    setParentPhone(savedGuardianSession.phone || savedGuardianSession.guardianPhone || savedParentPhone || hp || '');
    setParentSavedSessionAvailable(true);
    setParentCodeSent(false);
    setParentCode('');
    if (readParentRememberPreference() === 'true' && !isGuardianAutoLoginPaused()) {
      parentAutoLoginSessionRef.current = savedGuardianSession;
    }
    return;
  }

  if (isParentLoginCookie) {
    setLoginMode('parent');
    const phoneForRestore = savedParentPhone || hp || savedGuardianSession?.phone || savedGuardianSession?.guardianPhone || '';
    if (phoneForRestore) {
      setParentPhone(phoneForRestore);
    }
    setParentCodeSent(false);
    setParentCode('');
    return;
  }
}

  const handleGuestLogin = (event) => {
    event.preventDefault();
    navigate('/guest-login');
  };


function handleUpdate() {
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const platform = detectMobilePlatform(
    deviceKind,
    nativeVersionFromUrl,
    version,
    appVersion,
    userAgent
  );
  const storeUrl = appUpdateInfo?.storeUrl
    || APP_STORE_URLS[platform];
  if (!storeUrl) {
    alert('스토어 주소가 설정되지 않았습니다.');
    return;
  }

  if (window.webkit?.messageHandlers?.callWebSite) {
    window.webkit.messageHandlers.callWebSite.postMessage(storeUrl);
    return;
  }

  if (window.myJSInterface && typeof window.myJSInterface.callWebSite === 'function') {
    window.myJSInterface.callWebSite(storeUrl);
    return;
  }

  window.location.assign(storeUrl);
}

function handleSignUp() {
  navigate('/signup');
}

const parentNeedsReauth = /만료|다시 인증|인증번호를 다시/.test(parentMessage || '');
const showParentCodeControls = !parentSavedSessionAvailable || parentNeedsReauth;
const visibleParentMessage = parentNeedsReauth
  ? '저장된 로그인 정보가 만료되었습니다. 인증번호를 다시 받아 로그인해주세요.'
  : parentMessage;


  //===============================================
  return (
    <div className='BasicLogin' >
  

    <form onSubmit={handleSubmit}>
        <div className='title'>
          <p>{'AI K-EDU TALK'}</p>
          {/* <p>Learning Management System</p> */}
        </div>

      {signupCertCode && <p className="signup-complete-notice" role="status">회원가입이 완료되었습니다. 새 계정으로 로그인해 주세요.</p>}
      {passwordReset && <p className="signup-complete-notice" role="status">비밀번호를 변경했습니다. 새 비밀번호로 로그인해 주세요.</p>}

      {appUpdateInfo && (
        <section className='app-update-notice'>
          <strong>필수 업데이트가 필요합니다.</strong>
          <p>
            현재 {appUpdateInfo.installedVersion} · 최신 {appUpdateInfo.lastVersion}<br />
            업데이트한 후 로그인할 수 있습니다.
          </p>
          <Button type="button" className='btn-app-update' onClick={handleUpdate}>
            업데이트
          </Button>
        </section>
      )}

      {isAppVersionChecking && (
        <p className='app-version-checking'>앱 버전을 확인하고 있습니다.</p>
      )}

      {!isAppVersionChecking && !appUpdateInfo && (
        <>
      <div className='login-mode-tabs' aria-label='로그인 유형'>
        <button
          type='button'
          className={`login-mode-btn ${loginMode === 'student' ? 'active' : ''}`}
          disabled={parentLoading}
          onClick={() => handleLoginModeChange('student')}
        >
          학생 · 선생님
        </button>
        <button
          type='button'
          className={`login-mode-btn ${loginMode === 'parent' ? 'active' : ''}`}
          disabled={parentLoading}
          onClick={() => handleLoginModeChange('parent')}
        >
          학부모
        </button>
      </div>

      <div> 
        <label htmlFor="cerCode">* 인증코드</label> 
          <input
            type="text"
            id="cerCode"
            value={certCode}
            disabled
            spellCheck='false'
          /> 
      </div>

      {loginMode === 'student' ? (
        <>
          <div>
            <label htmlFor="userId">* 아이디</label>
              <input
                type="text"
                id="userId"
                ref={userIdRef}  // input 요소에 ref 속성을 설정
                value={userId}
                onChange={(e) => {
                  const nextUserId = e.target.value;
                  setUserId(nextUserId);
                  if (isIdChecked) fnc.setCookie(STUDENT_ID_STORAGE_KEY, nextUserId, 1000);
                }}
                autoComplete="username"
                spellCheck='false'
              />
          </div>

          <div>
            <label htmlFor="password">* 비밀번호</label>
              <input
                type="password"
                id="password"
                ref={passwordRef}
                value={password}
                onChange={(e) => {
                  const nextPassword = e.target.value;
                  setPassword(nextPassword);
                  if (isAutoLoginChecked) fnc.setCookie(STUDENT_PASSWORD_STORAGE_KEY, nextPassword, 30);
                }}
                autoComplete="current-password"
              />
          </div>

          <div className='box_menu'>
            <Button className='btn-login' type="submit">
                <i className="fa fa-user"></i> 로그인
            </Button>

            <button className='btn-login2' type="button" onClick={handleSignUp}>
              회원가입
            </button>

            {/* <Button className='btn-login2' type="button" onClick={handleGuestLogin}>
              <i className="fa fa-user"></i> 비회원 로그인
            </Button> */}

          </div>
          <nav className="login-recovery-links" aria-label="계정 찾기">
            <button type="button" onClick={() => navigate('/findId')}>아이디 찾기</button>
            <span aria-hidden="true">·</span>
            <button type="button" onClick={() => navigate('/findPw', { state: { recoveredLoginId: userId } })}>비밀번호 재설정</button>
          </nav>
        </>
      ) : (
        <>
          <div>
            <label htmlFor="parentPhone">* 학부모 휴대폰</label>
              <input
                type="tel"
                id="parentPhone"
                value={parentPhone}
                disabled={parentLoading}
                onChange={(e) => {
                  parentAutoLoginSessionRef.current = null;
                  setParentPhone(e.target.value);
                  setParentCodeSent(false);
                  setParentCode('');
                  setParentMessage('');
                }}
                placeholder='01012345678'
                inputMode='numeric'
                spellCheck='false'
              />
          </div>

          {showParentCodeControls && (
            <div className='parent-code-row'>
              <label htmlFor="parentCode">* 인증번호</label>
              <div className='parent-code-actions'>
                <input
                  type="text"
                  id="parentCode"
                  value={parentCode}
                  onChange={(e) => setParentCode(e.target.value)}
                  inputMode='numeric'
                  maxLength={6}
                  disabled={!parentCodeSent || parentLoading}
                  autoComplete="one-time-code"
                />
                <Button className='btn-code' type="button" onClick={handleParentSendCode} disabled={parentLoading}>
                  {parentLoading ? '전송중' : parentCodeSent ? '재전송' : '인증번호'}
                </Button>
              </div>
            </div>
          )}

          <section className="parent-remember">
            <label>
              <input type="checkbox" checked={parentRememberDevice} onChange={handleParentRememberChange}
                disabled={parentLoading} aria-describedby="parent-remember-help" />
              <span>이 기기에서 로그인 유지</span>
            </label>
            <p id="parent-remember-help">{parentRememberDevice
              ? '개인 기기에서만 선택해 주세요. 로그아웃 후에도 인증번호 없이 다시 로그인할 수 있습니다.'
              : '현재 탭에서만 로그인합니다. 다음 방문에는 문자 인증이 필요합니다.'}</p>
          </section>

          {parentSavedSessionAvailable && !visibleParentMessage && (
            <p className="parent-login-message">인증번호 없이 ‘학부모 로그인’을 눌러 주세요.</p>
          )}
          {visibleParentMessage && <p className='parent-login-message' role="status">{visibleParentMessage}</p>}

          <div className='box_menu parent-menu'>
            <Button className='btn-login' type="submit" disabled={parentLoading}>
              <i className="fa fa-user" aria-hidden="true"></i> {parentLoading ? '로그인 확인 중…' : '학부모 로그인'}
            </Button>
            {parentSavedSessionAvailable && (
              <button type="button" className="parent-forget-device" onClick={handleForgetGuardianDevice} disabled={parentLoading}>
                이 기기 인증 해제
              </button>
            )}
          </div>
        </>
      )}

      {loginMode === 'student' && (
        <section className="section-chkbox">
              <label className="form-check-label lblChk">
                  <Checkbox className="form-check-input" type="checkbox"
                  checked={isIdChecked} onChange={handleIdClick} /> &nbsp;아이디저장
              </label>
              <label className="form-check-label lblChk">
                  <Checkbox className="form-check-input" type="checkbox"
                  checked={isAutoLoginChecked}  onChange={handleAutoLoginClick} /> &nbsp;자동로그인
              </label>
        </section>
      )}
        </>
      )}

      <div className='ver-info'>{nativeVersionFromUrl || appVersion}</div>
      {/* <div className='ver-info'>토큰:{fcmToken}</div> */}

      <div className='privacy-policy'>
        <span onClick={() => setShowPrivacy(true)}>개인정보처리방침</span>
      </div>
    
    </form>

    {showPrivacy && (
      <div className='privacy-modal-overlay' onClick={() => setShowPrivacy(false)}>
        <div className='privacy-modal' onClick={(e) => e.stopPropagation()}>
          <div className='privacy-modal-header'>
            <span>개인정보처리방침</span>
            <button onClick={() => setShowPrivacy(false)}>&times;</button>
          </div>
          <iframe
            src="https://public-kuesb.s3.ap-northeast-2.amazonaws.com/PrivacyPolicy_keduTalk.html"
            title="개인정보처리방침"
          />
        </div>
      </div>
    )}

    </div>
  );


  
}


export default BasicLogin;
